import { hosts } from 'settings';

export const NavPlain = {
  template: `
    <nav class="navbar navbar-dark theme-dark navbar--main justify-content-center">
      <a class="navbar-brand--icon"
        ng-href="{{ $ctrl.publicUri }}">
        <nav-logo></nav-logo>
      </a>
    </nav>`,

  controller() {
    return {
      $onInit() {
        this.publicUri = /programs/.test(window.location.href)
          ? `${hosts.public}/programs`
          : `${hosts.public}`;
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Nav/NavPlain.js